import React, {Component} from 'react'
import {Jumbotron, Card, CardBody} from 'reactstrap'

class Dashboard extends Component {
  state = {

  }

  render(){
    return (
      <Card className="text-white bg-gray text-center">
        <CardBody>
            <h3 className="text-muted text-uppercase font-weight-bold"></h3>
        </CardBody>
      </Card>
    )
  }
}

export default Dashboard


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Dashboard.js